import { format } from 'date-fns'

// Historia 226 (MIC-4441): i18n keys (= English text, `impacto.md` §i18n) for the literals Sun sends in the printer and
// print-record DTOs. Jupiter translates the `outcome`, never shows Sun's English `reason` in its notices.

export const AVAILABILITY_TEXT = {
  AVAILABLE: 'Available',
  NOT_CHECKED: 'Not checked',
  UNAVAILABLE: 'Unavailable'
}

export const AVAILABILITY_COLOR = {
  AVAILABLE: 'success',
  NOT_CHECKED: 'default',
  UNAVAILABLE: 'error'
}

export const OUTCOME_TEXT = {
  PRINTED: 'Printed',
  PRINTER_UNREACHABLE: 'The printer does not respond',
  PRINTER_STATUS_UNKNOWN: 'The printer does not report its status',
  PRINTER_NOT_READY: 'The printer is not ready',
  PRINTER_INACTIVE: 'The printer is inactive',
  PRINTER_NOT_FOUND: 'The printer no longer exists',
  ENTITY_NOT_FOUND: 'The element no longer exists or is inactive',
  TEMPLATE_NOT_FOUND: 'The template version no longer exists',
  INVALID_PRINTER_CONFIGURATION: 'Printer configuration is invalid',
  INVALID_REQUEST: 'Invalid print request',
  UNEXPECTED_ERROR: 'Unexpected error'
}

export const PROBLEM_TEXT = {
  PAPER_OUT: 'Paper out',
  PAUSED: 'Paused',
  HEAD_OPEN: 'Head open',
  RIBBON_OUT: 'Ribbon out',
  RECEIVE_BUFFER_FULL: 'Receive buffer full',
  OVER_TEMPERATURE: 'Over temperature',
  CORRUPT_RAM: 'Corrupt RAM'
}

export const LAYOUT_TEXT = {
  HORIZONTAL: 'Landscape: QR on the left',
  VERTICAL: 'Portrait: QR on top'
}

export const PRINT_METHOD_TEXT = {
  DIRECT_THERMAL: 'Direct thermal',
  THERMAL_TRANSFER: 'Thermal transfer'
}

export const DPI_OPTIONS = [152, 203, 300, 600]

// An unknown literal (a newer Sun) is shown as it comes rather than hidden.
export const textOf = (catalogue, literal) => catalogue[literal] || literal || ''

export const labelSizeText = ({ labelWidthMm, labelHeightMm }) => `${labelWidthMm} × ${labelHeightMm} mm`

// E6: effective print width = configured ?? reported by the printer ?? the label's own width.
export const effectivePrintWidth = ({ printWidthMm, reportedPrintWidthMm, labelWidthMm }) => {
  if (printWidthMm) return { width: printWidthMm, reported: false }
  if (reportedPrintWidthMm) return { width: reportedPrintWidthMm, reported: true }
  return { width: labelWidthMm, reported: false }
}

// Contract: ISO-8601 UTC from Sun, shown in the browser's local time as dd/MM/yyyy HH:mm:ss.
export const localDateTimeText = (iso) => (iso ? format(new Date(iso), 'dd/MM/yyyy HH:mm:ss') : '')
